import { FunctionComponent } from 'react';
import {
  Avatar,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { TeamLite } from './types';

type GroupTeamPickerProps = {
  /** Times disponíveis para alocar (selected − já alocados em qualquer grupo). */
  availableTeams: TeamLite[];
  buttonLabel: string;
  onPick: (teamUuid: string) => void;
};

/**
 * Botão "+ Adicionar time ao grupo" que abre um Menu com os times selecionados
 * que ainda não foram alocados em nenhum grupo.
 */
export const GroupTeamPicker: FunctionComponent<GroupTeamPickerProps> = ({
  availableTeams,
  buttonLabel,
  onPick,
}) => {
  const { t } = useTranslation();
  const isEmpty = availableTeams.length === 0;

  return (
    <Menu placement="bottom-start">
      <MenuButton
        as={Button}
        variant="outline"
        size="sm"
        leftIcon={<ChakraFeatherIcon name="plus" boxSize="14px" />}
        color="gray.600"
        w="100%"
      >
        {buttonLabel}
      </MenuButton>
      <MenuList maxH="240px" overflowY="auto" minW="240px">
        {isEmpty ? (
          <Flex direction="column" gap={1} px={3} py={3} color="gray.500">
            <Text fontSize="13px">
              {t(
                'pages.application_season.components.season_step3_teams.groups.picker_empty',
              )}
            </Text>
          </Flex>
        ) : null}
        {availableTeams.map((team, index) => (
          <Flex key={team.uuid} direction="column">
            {index > 0 ? <MenuDivider m={0} /> : null}
            <MenuItem onClick={() => onPick(team.uuid)}>
              <Flex align="center" gap={2}>
                <Avatar size="xs" name={team.acronym || team.name} src={team.logo_path} />
                <Text fontSize="13px">{team.name}</Text>
              </Flex>
            </MenuItem>
          </Flex>
        ))}
      </MenuList>
    </Menu>
  );
};
